import { getBaseUrl } from '@/utils';

export const API_CONFIG = {
  BASE_URL: process.env.REACT_APP_API_BASE_URL,
  TIMEOUT: 30000, // 30 seconds
};

export const AUTH_API_ENDPOINTS = {
  AUTH_LOGIN: `${getBaseUrl()}/auth/login`,
  AUTH_FORGOT_PASSWORD: `${getBaseUrl()}/auth/forgot-password`,
  AUTH_CHANGE_PASSWORD: `${getBaseUrl()}/auth/change-password`,
  AUTH_PASSWORD_RESETS_VERIFY: `${getBaseUrl()}/auth/password-resets/verify`,
  AUTH_LOGOUT: `${getBaseUrl()}/auth/logout`,
  AUTH_PROFILE: `${getBaseUrl()}/auth/profile`,
  AUTH_SEND_OTP: `${getBaseUrl()}/auth/email/:email/send/otp`,
  AUTH_RESEND_OTP: `${getBaseUrl()}/auth/access-control/:email/resend`,
  AUTH_VERIFY_OTP: `${getBaseUrl()}/auth/access-control/verify`,
};

export const REGULATORY_JOBS_API_ENDPOINTS = {
  JOBS_SEARCH: `${getBaseUrl()}/jobs/search`,
  JOB_DETAILS: `${getBaseUrl()}/jobs/:jobId`,
  JOB_RETRY: `${getBaseUrl()}/jobs/:jobId/retry`,
  JOBS_MANUAL_TRIGGER: `${getBaseUrl()}/jobs/trigger`,
  JOBS_RETRY_FAILURE_NOTIFICATIONS: `${getBaseUrl()}/jobs/:jobId/notifications/retry`,
};

export const SOURCES_API_ENDPOINTS = {
  SOURCE_DETAILS: `${getBaseUrl()}/sources`,
};

export const REGULATORY_NOTIFICATIONS_API_ENDPOINTS = {
  NOTIFICATIONS_SEARCH: `${getBaseUrl()}/notifications/search`,
  NOTIFICATIONS_DETAILS: `${getBaseUrl()}/notifications/:emailId`,
  NOTIFICATION_RECLASSIFY: `${getBaseUrl()}/notifications/:emailId/reclassify`,
  NOTIFICATION_RETRY: `${getBaseUrl()}/notifications/:emailId/retry`,
  NOTIFICATION_ATTENTION_DOCUMENTS: `${getBaseUrl()}/notifications/:emailId/documents/attention`,
  NOTIFICATION_RESOLVE_WITH_DOCUMENT: `${getBaseUrl()}/notifications/:emailId/documents/:documentId/upload/:fileName/resolve`,
  NOTIFICATION_RESOLVE_WITHOUT_DOCUMENT: `${getBaseUrl()}/notifications/:emailId/documents/:documentId/resolve`,
  NOTIFICATION_TRANSFER_TO_N1: `${getBaseUrl()}/notifications/:emailId/resolve`,
  NOTIFICATION_REVERT_DOCUMENT: `${getBaseUrl()}/notifications/:emailId/documents/:documentId/revert`,
};

export const USER_MANAGEMENT_API_ENDPOINTS = {
  USER_SEARCH: `${getBaseUrl()}/users/search`,
  AUDIT_LOG_SEARCH: `${getBaseUrl()}/users/changes/logs`,
  USER_DETAILS: `${getBaseUrl()}/users/:id`,
  USER_CREATION: `${getBaseUrl()}/users`,
  USER_UPDATE: `${getBaseUrl()}/users/:id`,
  DEACTIVATE_USER: `${getBaseUrl()}/users/:id/deactivate`,
  REACTIVATE_USER: `${getBaseUrl()}/users/:id/reactivate`,
  RESEND_INVITATION: `${getBaseUrl()}/users/:id/invitations/resend`,
  DELETE_USER: `${getBaseUrl()}/users/:id`,
  INITIATE_PASSWORD: `${getBaseUrl()}/users/passwords/initiate`,
};
